import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    content: {
        textAlign: 'center',
        padding: 10,
    },
    img: {
        width: '100%',
        padding: 10,
        border: '1px solid #ddd' ,
        maxHeight: 270,
        [theme.breakpoints.down('xs')]: {
            maxHeight: 400,
        },
    }
}))
